import { PickupType, ServiceArea } from '@core/redux/stores';

export class LocationConstants {
  public static OFFSITE_MESSAGE: string = 'Order Off-Site Only';
  public static LOCATION_TRACKING_MESSAGE: string = 'Allow Location Services';
  public static PickupCapabilities = [
    'Curbside',
    'DI',
    'DRT',
    'Take-Out',
    'Delivery'
  ];
  public static PickupTypeMetaDataList = [{
    text: 'Dine In',
    pickupType: PickupType.DineIn,
    serviceAreas: [ServiceArea.DineIn],
    amenities: ['DI'],
    fallbackPickupTypes: [PickupType.DriveThru, PickupType.TakeOut, PickupType.Curbside],
    pointOfSalePickupTypes: [PickupType.DineIn],
    idText: 'dinein',
    iconClass: 'xs-dinein-icon',
    sort: 1
  }, {
    text: 'Take Out',
    pickupType: PickupType.TakeOut,
    serviceAreas: [ServiceArea.DineIn],
    amenities: ['Take-Out'],
    fallbackPickupTypes: [PickupType.DriveThru, PickupType.DineIn, PickupType.Curbside],
    pointOfSalePickupTypes: [PickupType.TakeOut],
    idText: 'takeout',
    iconClass: 'xs-takeout-icon',
    sort: 2
  }, {
    text: 'Drive Thru',
    pickupType: PickupType.DriveThru,
    serviceAreas: [ServiceArea.DriveThru],
    amenities: ['DRT'],
    fallbackPickupTypes: [PickupType.DineIn, PickupType.TakeOut, PickupType.Curbside],
    pointOfSalePickupTypes: [PickupType.DriveThru],
    idText: 'drivethru',
    iconClass: 'xs-drivethru-icon',
    sort: 3
  }, {
    text: 'Curbside',
    pickupType: PickupType.Curbside,
    serviceAreas: [ServiceArea.DineIn, ServiceArea.DriveThru],
    amenities: ['Curbside'],
    fallbackPickupTypes: [PickupType.DriveThru, PickupType.TakeOut, PickupType.DineIn],
    pointOfSalePickupTypes: [PickupType.TakeOut, PickupType.DriveThru],
    idText: 'curbside',
    iconClass: 'xs-curbside-icon',
    sort: 4
  }, {
    text: 'Delivery',
    pickupType: PickupType.Delivery,
    serviceAreas: [ServiceArea.DineIn, ServiceArea.DriveThru],
    amenities: ['Delivery'],
    fallbackPickupTypes: [PickupType.DriveThru, PickupType.TakeOut, PickupType.Curbside, PickupType.DineIn],
    pointOfSalePickupTypes: [PickupType.TakeOut, PickupType.DriveThru],
    idText: 'delivery',
    iconClass: 'xs-delivery-icon',
    labelText: 'Delivery (May Add Cost)',
    sort: 5
  }];
}